export const ROUTE_PATH = '/reconciliation-receipts/store[eq]=:store_id';

export const ARCHIVE_ROUTE_PATH =
  '/reconciliation-receipts/reconciliation_id[eq]=:reconciliation_id&store_id[eq]=:store_id';

export const FEATURE_NAME = 'reconciliationReceiptsPage';
